module.exports = __webpack_public_path__ + "static/media/ojo.8806479b.svg";